/**
 * Dedicated portal hostnames — browser side.
 *
 * Routing is activated only by an exact hostname match. The hostnames and the
 * route-ownership table live in ONE runtime-agnostic module,
 * src/lib/portalHosts.ts, which the Vercel Edge Middleware imports too, so the
 * edge and the browser can never disagree (PAWTENANT-BRANDED-PORTAL-HOSTS-LIVE-001).
 * Preview deployments, *.vercel.app, www and localhost render the public shell
 * with every route reachable, exactly as before.
 */
import { LIVE_PORTAL_HOSTS, resolveHost } from "./portalHosts";

export const ADMIN_HOSTNAME = LIVE_PORTAL_HOSTS.admin;
export const CUSTOMER_HOSTNAME = LIVE_PORTAL_HOSTS.customer;
export const PROVIDER_HOSTNAME = LIVE_PORTAL_HOSTS.provider;
export const PARTNER_HOSTNAME = LIVE_PORTAL_HOSTS.partner;
export const PUBLIC_HOSTNAME = LIVE_PORTAL_HOSTS.public;

export type PortalHostname = "admin" | "customer" | "provider" | "partner";

export function getPortalHostname(): PortalHostname | null {
  if (typeof window === "undefined") return null;
  const resolved = resolveHost(window.location.hostname);
  if (!resolved.isolated || resolved.portal === "public") return null;
  return resolved.portal;
}

export function isAdminSubdomain(): boolean {
  return getPortalHostname() === "admin";
}
